import { Typography } from "@packages/ds";
import styled from "styled-components";

import DsPageDescription from "Components/PageDescription";
import { Button, AddButton as DsAddButton } from "ds/Button";
import * as Table from "ds/Table";
import { semiBoldAlias } from "Libs/theme";

export const AddButton = styled(DsAddButton)`
  float: right;
  text-transform: capitalize;
`;
export const Title = styled(Typography.Title)`
  margin-bottom: 16px;
  text-transform: capitalize;
`;
export const PageDescription = styled(DsPageDescription)`
  margin-bottom: 18px;
`;

export const InfoLayout = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .domains {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 504px;
    white-space: nowrap;
  }
  .expires {
    font-size: 13px;
    color: var(--label-slate-color, var(--slate));
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${semiBoldAlias()};
  }
  @media (min-width: 900px) {
    flex-direction: row;
    .expires {
      width: 275px;
      padding-left: 20px;
    }
  }
`;

export const CertificateExpanded = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
`;

export const CertificateWrapper = styled.div`
  button.delete,
  button.edit {
    margin: 0;
  }
  button.outline {
    float: right;
    &:hover {
      border: 1px solid
        var(--button-color-primary-800-border-color, var(--color-primary-800));
      margin: -1px;
    }
  }
`;

export const FieldGroup = styled.div`
  margin-bottom: 16px;
  display: flex;
  color: var(--section-dark-tint-color, var(--dark-tint));
  font-size: 15px;
  line-height: 20px;
  label {
    width: 90px;
    line-height: 20px;
    margin-bottom: 0;
  }
  .domain + .domain,
  .issuer + .issuer {
    margin-top: 5px;
  }
`;

export const DeleteButton = styled(Button)`
  float: right;
`;

export const NoteWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 36px;
  font-size: 14px;
  line-height: 26px;
  color: var(--section-ebony-light-color, var(--ebony-light));
`;

export const TableThead = styled(Table.Thead)`
  padding-right: 24px;
  justify-content: space-between;
  width: 94%;
`;

export const TableTh = styled(Table.Th)<{ first?: boolean }>`
  max-width: ${props => (props.first ? "504px" : "unset")};
  @media (min-width: 900px) {
    width: ${props => (!props.first ? "275px" : "100%")};
  }
`;
